import { upperFirst, camelCase } from 'lodash';

var styles = {"alignLeft":"z0VD0","textWrapNowrap":"EpJcV","alignRight":"SlRJ8","alignCenter":"uD4JE","sizeFullWidth":"X73CH","renderedInTable":"gqI-v","sizeOriginal":"DSLOg","sizeContent":"m7KU9","sizeSmall":"_-5voY","sizeSmallCenter":"_1NpMp","flex":"C-CdU","atomic":"H5zMd","anchor":"XBFdh","embed":"NB1yV","horizontalScrollbar":"jVTBR","pluginContainerMobile":"_7AesQ"};

const getContainerData = (node) => {
  var _a;
  const data = `${camelCase(node.type)}Data`;
  return (_a = node == null ? void 0 : node[data]) == null ? void 0 : _a.containerData;
};
const getAlignmentClassName = (containerData = {}) => {
  const { alignment } = containerData;
  if (!alignment) {
    return "";
  }
  const key = `align${upperFirst(alignment.toLowerCase())}`;
  return styles[key];
};
const getSizeClassName = (containerData) => {
  const { width } = containerData;
  const { size } = width || {};
  if (!size) {
    return "";
  }
  const key = `size${upperFirst(camelCase(size.toLowerCase()))}`;
  return styles[key];
};
const getTextWrapClassName = (containerData = {}) => {
  const { textWrap } = containerData;
  if (textWrap) {
    return "";
  }
  return styles.textWrapNowrap;
};
const alignmentClassName = (node) => {
  return getAlignmentClassName(getContainerData(node));
};
const sizeClassName = (node) => {
  return getSizeClassName(getContainerData(node) || {});
};
const textWrapClassName = (node) => {
  return getTextWrapClassName(getContainerData(node));
};

export { getSizeClassName as a, getTextWrapClassName as b, alignmentClassName as c, sizeClassName as d, getAlignmentClassName as g, styles as s, textWrapClassName as t };
//# sourceMappingURL=getClassNames-a8798f64.js.map
